import { defineStore } from 'pinia';

export const useBuildPriceMenuStore = defineStore('buildPriceMenuStore', {
  state() {
    return {
      showHorizontalBuildPriceMenu: false,
    };
  },
});
